module.exports = __webpack_public_path__ + "static/healthplans-828cddce068a16a25cab030a9f6eadd0.jpg";